var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wating_mask",class:{ show: _vm.showWaiting }},[_c('div',{staticClass:"tips_box"},[_vm._v(_vm._s(_vm.$t('msg.waiting')))])])}
var staticRenderFns = []

export { render, staticRenderFns }